import { render, staticRenderFns } from "./column2-charts.vue?vue&type=template&id=03207d9d&scoped=true"
import script from "./column2-charts.vue?vue&type=script&lang=ts"
export * from "./column2-charts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03207d9d",
  null
  
)

export default component.exports